/*
 *   This content is licensed according to the W3C Software License at
 *   https://www.w3.org/Consortium/Legal/2015/copyright-software-and-document
 */

export const mediaQuery = 'only screen and (max-width: 639px)';

const accordions = [];

export function bootstrap() {
  const notes = document.querySelectorAll('.s-sci-prose__fn');

  notes.forEach(note => {
    const accordion = new Accordion(note.querySelector('.s-sci-prose__fn-ref'), note.querySelector('.s-sci-prose__fn-content'));
    accordions.push(accordion);
  });
}

export function destroy() {
  accordions.forEach(accordion => {
    accordion.destroy();
  });
}

class Accordion {
  constructor(buttonEl, contentEl) {
    this.buttonEl = buttonEl;
    this.contentEl = contentEl;

    this.open = this.buttonEl.getAttribute('aria-expanded') === 'true';
    this.onOpen = null;

    // add event listeners
    const self = this;
    this.onButtonClick = e => {
      e.preventDefault();
      self.toggle(!self.open);
    };

    this.buttonEl.addEventListener('click', this.onButtonClick);
    
    this.duration = 500;
  }

  toggle(open) {
    if (open === this.open) {
      return;
    }

    this.open = open;
    this.buttonEl.setAttribute('aria-expanded', `${open}`);

    if (open) {
      // Opening
      const self = this;
      this.contentEl.classList.add('s-sci-prose__fn-content--open');
      this.contentEl.animate(
        [
          {
            height: '0px',
            paddingTop: '0em',
            paddingBottom: '0em',
            opacity: 0,
            easing: 'ease-in-out'
          },
          {
            height: this.contentEl.clientHeight.toString() + 'px',
            paddingTop: '1em',
            paddingBottom: '1em',
            opacity: 0,
            easing: 'linear'
          },
          {
            height: this.contentEl.clientHeight.toString() + 'px',
            paddingTop: '1em',
            paddingBottom: '1em',
            opacity: 1
          }
        ],
        {
          duration: this.duration
        }
      )
      .addEventListener('finish', () => {

      });

      if (this.onOpen) {
        this.onOpen.call(this);
      }
    } else {
      // Closing
      const self = this;
      this.contentEl.animate(
        [
          {
            height: this.contentEl.clientHeight.toString() + 'px',
            paddingTop: '1em',
            paddingBottom: '1em',
            opacity: 1,
            easing: 'linear'
          },
          {
            height: this.contentEl.clientHeight.toString() + 'px',
            paddingTop: '1em',
            paddingBottom: '1em',
            opacity: 0,
            easing: 'ease-in-out'
          },
          {
            height: '0px',
            paddingTop: '0em',
            paddingBottom: '0em',
            opacity: 0
          }
        ],
        {
          duration: this.duration,
          easing: this.ease
        }
      )
      .addEventListener('finish', () => {
        self.contentEl.classList.remove('s-sci-prose__fn-content--open');
      });
    }
  }

  open() {
    this.toggle(true);
  }

  close() {
    this.toggle(false);
  }

  destroy() {
    this.contentEl.classList.remove('s-sci-prose__fn-content--open');
    this.buttonEl.removeEventListener('click', this.onButtonClick);
  }
}